export default `layout
  name: circle 

n1 - n2
n2 - n3
n3 - n1

all nodes
  background: green
  label: ""

all edges
  color: green
  label: ""




`;